import React, { Dispatch, FC, SetStateAction, useState } from 'react'
import { MagnifyingGlass } from '../../../icons'

export const InteractiveInput: FC<{
  label: string
  value: string
  disabled?: boolean
  setValue: Dispatch<SetStateAction<string>>
}> = ({ label, value, disabled = false, setValue }) => {
  const [isFocused, setIsFocused] = useState(false)

  const handleFocus = () => setIsFocused(true)
  const handleBlur = () => setIsFocused(false)
  const handleChange = (e) => setValue(e.target.value)

  return (
    <div className='relative mt-7'>
      <div
        className={`
          h-9
          px-2.5
          py-1
          bg-zinc-100
          rounded-md
          shadow-[0px_0.5px_2px_rgba(0,0,0,0.25)]
          shadow-[inset_0px_0.8px_2px_rgba(0,0,0,0.15)]
          inline-flex justify-start items-center gap-1
          w-full
           ${
             isFocused
               ? 'outline outline-1 outline-offset-[-1px] outline-sky-200'
               : ''
           }
        `}
      >
        <div className='flex-1 inline-flex flex-col justify-center items-start overflow-hidden'>
          {isFocused && (
            <label className="text-[#37A2BA] pl-1 pt-1 text-[10px] font-normal font-['DM_Sans'] leading-3">
              {label}
            </label>
          )}
          <input
            disabled={disabled}
            type='text'
            value={value}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onChange={handleChange}
            placeholder={!isFocused ? label : ''}
            className={`
              w-full
              text-slate-900
              text-sm
              font-normal
              font-['DM_Sans']
              leading-tight
              tracking-wide
              placeholder:text-slate-400
              !border-none
              bg-transparent
              focus:ring-0
              focus:ring-transparent
              ${isFocused ? 'pt-0' : 'pt-1'}
            `}
          />
        </div>
        <div className='w-4 h-4 relative pointer-events-none mr-2'>
          <MagnifyingGlass className='w-4 h-4 text-[#001A3D]' />
        </div>
      </div>
    </div>
  )
}
